/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	CosmosEntityFragment,
	PageHeroesFragment,
	RefSectionsEntitiesFragment,
	RefSectionsFragment,
} from "@cosmos/hygraph-schema";

import { getHeroDetails } from "./cosmosHeroQuery";
import { getRefSectionDetails, getRefSectionEntities } from "./cosmosSectionQuery";
import { HeroQuery } from "./page.types";

export type GetHeroAndSectionsDetailsOptions = {
	locale: string;
	slug: string;
	lang: string;
	preview?: string;
	endpoint?: string;
};

export type GetHeroAndSectionsDetailsResponse = {
	hero: PageHeroesFragment | null;
	refSections: RefSectionsFragment[];
};

export const getHeroAndSectionsDetails = async (
	heroEntity: CosmosEntityFragment | undefined | null,
	refSectionsEntities: RefSectionsEntitiesFragment[] | undefined,
	{ locale, lang, preview, endpoint }: GetHeroAndSectionsDetailsOptions,
): Promise<GetHeroAndSectionsDetailsResponse> => {
	const heroPromise: Promise<HeroQuery | null> = getHeroDetails(heroEntity, locale, preview, endpoint);
	const sectionsPromises = getRefSectionEntities(refSectionsEntities, locale, lang, preview, endpoint) || [];

	const [heroResponse, sectionsResponses] = await Promise.all([heroPromise, Promise.all(sectionsPromises)]);

	const refSections: RefSectionsFragment[] = getRefSectionDetails(sectionsResponses);

	if (heroResponse?.entities?.length && heroResponse.entities[0]) {
		return { hero: heroResponse.entities[0] as PageHeroesFragment, refSections };
	}

	return { hero: null, refSections };
};
